import { z } from '@harvestiq/zod';
import { sharedEndorsementSchema } from './shared';
import { dbLgmEndorsementSchema } from './db-lgm-endorsement';

export const lgmEndorsementSchema = dbLgmEndorsementSchema.merge(
  sharedEndorsementSchema
);

export type LgmEndorsement = z.infer<typeof lgmEndorsementSchema>;
